import gql from 'graphql-tag';
export type Maybe<T> = T | undefined;
export type InputMaybe<T> = T | undefined;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  Currency: any;
  Date: any;
  DateTime: any;
  EmailAddress: any;
  JSONObject: any;
  NonNegativeFloat: any;
  PhoneNumber: any;
};

export type Account = {
  __typename?: 'Account';
  activeOrders: Array<Order>;
  address?: Maybe<Address>;
  allActivities: Array<OrderItemGroup>;
  archiveOrders: Array<Order>;
  availableProducts: Array<Product>;
  cart?: Maybe<Cart>;
  children: Array<Child>;
  consents: AccountConsents;
  contactInfo?: Maybe<ContactInfo>;
  guardians: Array<Guardian>;
  id: Scalars['ID'];
  isIncomplete: Scalars['Boolean'];
  membership?: Maybe<Membership>;
  name?: Maybe<Scalars['String']>;
  order?: Maybe<Order>;
  ordersSummary: OrdersSummary;
  pesel?: Maybe<Scalars['String']>;
  surname?: Maybe<Scalars['String']>;
};


export type AccountAvailableProductsArgs = {
  category: Scalars['String'];
  period?: InputMaybe<TimePeriodInput>;
};


export type AccountOrderArgs = {
  id: Scalars['ID'];
};

export type AccountChildUpdateInput = {
  address: AddressInput;
  birthday: Scalars['Date'];
  health?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  pesel: Scalars['String'];
  surname: Scalars['String'];
};

export type AccountConsents = {
  __typename?: 'AccountConsents';
  call?: Maybe<Scalars['Boolean']>;
  email?: Maybe<Scalars['Boolean']>;
  health?: Maybe<Scalars['Boolean']>;
  healthProcessing?: Maybe<Scalars['Boolean']>;
  knowledge?: Maybe<Scalars['Boolean']>;
  text?: Maybe<Scalars['Boolean']>;
};

export type AccountConsentsInput = {
  call?: InputMaybe<Scalars['Boolean']>;
  email?: InputMaybe<Scalars['Boolean']>;
  health?: InputMaybe<Scalars['Boolean']>;
  healthProcessing?: InputMaybe<Scalars['Boolean']>;
  knowledge?: InputMaybe<Scalars['Boolean']>;
  text?: InputMaybe<Scalars['Boolean']>;
};

export type AccountGuardianUpdateInput = {
  contactInfo: ContactInfoInput;
  name: Scalars['String'];
  surname: Scalars['String'];
};

export type AccountUpdateInput = {
  address?: InputMaybe<AddressInput>;
  consents?: InputMaybe<AccountConsentsInput>;
  contactInfo?: InputMaybe<ContactInfoInput>;
  name?: InputMaybe<Scalars['String']>;
  pesel?: InputMaybe<Scalars['String']>;
  surname?: InputMaybe<Scalars['String']>;
};

export type ActivityProduct = IProduct & {
  __typename?: 'ActivityProduct';
  additionalProperties?: Maybe<Array<AdditionalPropertyField>>;
  categories: Array<ProductCategory>;
  category: ProductCategory;
  durationMinutes: Scalars['Int'];
  location: Scalars['String'];
  name: Scalars['String'];
  price: Price;
  sku: Scalars['ID'];
  sport: Scalars['String'];
  stock?: Maybe<ProductStockInformation>;
  type: Scalars['String'];
};

export type AdditionalPropertyField = AdditionalPropertyFieldCustom | AdditionalPropertyFieldSelect | PriceOverrideField;

export type AdditionalPropertyFieldCustom = IAdditionalPropertyField & {
  __typename?: 'AdditionalPropertyFieldCustom';
  description?: Maybe<Scalars['String']>;
  displayName: Scalars['String'];
  kind: AdditionalPropertyFieldCustomKind;
  name: Scalars['String'];
};

export enum AdditionalPropertyFieldCustomKind {
  Color = 'COLOR',
  Text = 'TEXT'
}

export type AdditionalPropertyFieldPriceModifier = {
  __typename?: 'AdditionalPropertyFieldPriceModifier';
  total?: Maybe<Scalars['Float']>;
  unit?: Maybe<Scalars['Float']>;
};

export type AdditionalPropertyFieldSelect = IAdditionalPropertyField & {
  __typename?: 'AdditionalPropertyFieldSelect';
  description?: Maybe<Scalars['String']>;
  displayName: Scalars['String'];
  kind: AdditionalPropertyFieldSelectKind;
  name: Scalars['String'];
  options: Array<AdditionalPropertyFieldSelectOption>;
};

export enum AdditionalPropertyFieldSelectKind {
  Checkbox = 'CHECKBOX',
  Multicheckbox = 'MULTICHECKBOX',
  Multiselect = 'MULTISELECT',
  Radio = 'RADIO',
  Select = 'SELECT'
}

export type AdditionalPropertyFieldSelectOption = {
  __typename?: 'AdditionalPropertyFieldSelectOption';
  description?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  priceModifier?: Maybe<AdditionalPropertyFieldPriceModifier>;
  value: Scalars['String'];
};

export type Address = {
  __typename?: 'Address';
  city?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['String']>;
  street?: Maybe<Scalars['String']>;
};

export type AddressInput = {
  city?: InputMaybe<Scalars['String']>;
  code?: InputMaybe<Scalars['String']>;
  street?: InputMaybe<Scalars['String']>;
};

export type BaseProduct = IProduct & {
  __typename?: 'BaseProduct';
  additionalProperties?: Maybe<Array<AdditionalPropertyField>>;
  categories: Array<ProductCategory>;
  category: ProductCategory;
  name: Scalars['String'];
  price: Price;
  sku: Scalars['ID'];
  stock?: Maybe<ProductStockInformation>;
};

export type CampProduct = IProduct & {
  __typename?: 'CampProduct';
  additionalProperties?: Maybe<Array<AdditionalPropertyField>>;
  categories: Array<ProductCategory>;
  category: ProductCategory;
  name: Scalars['String'];
  price: Price;
  sku: Scalars['ID'];
  stock?: Maybe<ProductStockInformation>;
};

export type Cart = {
  __typename?: 'Cart';
  account: Account;
  discountCodes: Array<Maybe<CartDiscountCode>>;
  discounts: Array<CartDiscount>;
  id: Scalars['ID'];
  items: Array<CartItem>;
  itemsGroups: Array<CartItemGroup>;
  paymentOptions: Array<PaymentOption>;
  problems: Array<CartProblem>;
};

export type CartDiscount = {
  __typename?: 'CartDiscount';
  code: CartDiscountType;
  discountValue: CartDiscountValue;
  message: Scalars['String'];
  reason?: Maybe<Scalars['String']>;
  source: CartDiscountSource;
};

export type CartDiscountCode = {
  __typename?: 'CartDiscountCode';
  accountId?: Maybe<Scalars['ID']>;
  code: Scalars['ID'];
  description: Scalars['String'];
  expirationDate?: Maybe<Scalars['Date']>;
};

export enum CartDiscountSource {
  Cart = 'CART',
  Item = 'ITEM'
}

export enum CartDiscountType {
  Percentage = 'PERCENTAGE',
  Value = 'VALUE'
}

export type CartDiscountValue = DiscountPercentage | Price;

/**
 * CartItem represents single product we can sell
 * - For memberships it is a single membership for a person (Account Or Child)
 * - For activity it is a repeatable activity with key identifiable properties:
 *   - sport
 *   - location
 *   - type
 *   - day
 *   - time
 */
export type CartItem = CartItemActivity | CartItemMembership | CartItemNewWinterCamp | CartItemSummerCamp | CartItemWinterCamp;

export type CartItemActivity = ICartItem & {
  __typename?: 'CartItemActivity';
  customData: Scalars['JSONObject'];
  day: Scalars['String'];
  discounts: Array<CartItemDiscount>;
  entries: Array<Scalars['Date']>;
  id: Scalars['ID'];
  location: Scalars['String'];
  originalPrice: Price;
  originalUnitPrice: Price;
  participant: Participant;
  period: Period;
  price: Price;
  sku: Scalars['ID'];
  sport: Scalars['String'];
  time: Scalars['String'];
  type: Scalars['String'];
  unitPrice: Price;
};

export type CartItemActivityBundle = {
  __typename?: 'CartItemActivityBundle';
  dayTimes: Array<CartItemActivityBundleDayTime>;
  discounts: Array<CartItemDiscount>;
  entries: Array<Scalars['DateTime']>;
  location: Scalars['String'];
  originalPrice: Price;
  originalUnitPrice: Price;
  participant: Participant;
  paymentPrice?: Maybe<Price>;
  period: Period;
  price: Price;
  sport: Scalars['String'];
  type: Scalars['String'];
  unitPrice: Price;
};

export type CartItemActivityBundleDayTime = {
  __typename?: 'CartItemActivityBundleDayTime';
  day: Scalars['String'];
  time: Scalars['String'];
};

/**
 * CartItemBundle contain memberships and bundles of activities.
 * Activity bundle is group of activities with the same:
 *   - sport
 *   - location
 *   - type
 */
export type CartItemBundle = CartItemActivityBundle | CartItemMembership | CartItemNewWinterCamp | CartItemSummerCamp | CartItemWinterCamp;

export type CartItemCustomDataInput = {
  data: Scalars['JSONObject'];
  itemId: Scalars['ID'];
};

export type CartItemDiscount = {
  __typename?: 'CartItemDiscount';
  code: CartDiscountType;
  discountValue: CartDiscountValue;
  message: Scalars['String'];
  reason?: Maybe<Scalars['String']>;
  source: CartDiscountSource;
};

/** CartItemGroup groups CartItem and CartItemBundle for given participant. */
export type CartItemGroup = {
  __typename?: 'CartItemGroup';
  bundles: Array<CartItemBundle>;
  items: Array<CartItem>;
  participant: Participant;
  problems?: Maybe<Array<CartProblem>>;
};

export type CartItemMembership = ICartItem & {
  __typename?: 'CartItemMembership';
  customData: Scalars['JSONObject'];
  discounts: Array<CartItemDiscount>;
  end?: Maybe<Scalars['Date']>;
  id: Scalars['ID'];
  originalPrice: Price;
  participant: Participant;
  paymentPrice?: Maybe<Price>;
  period: Period;
  price: Price;
  sku: Scalars['ID'];
  start?: Maybe<Scalars['Date']>;
  type: MembershipType;
};

export type CartItemMembershipInput = {
  end: Scalars['Date'];
  start: Scalars['Date'];
  type: MembershipType;
};

export type CartItemNewWinterCamp = ICartItem & {
  __typename?: 'CartItemNewWinterCamp';
  customData: Scalars['JSONObject'];
  discounts: Array<CartItemDiscount>;
  id: Scalars['ID'];
  name: Scalars['String'];
  originalPrice: Price;
  participant: Participant;
  paymentPrice?: Maybe<Price>;
  price: Price;
  profile: Scalars['String'];
  sku: Scalars['ID'];
};

export type CartItemSummerCamp = ICartItem & {
  __typename?: 'CartItemSummerCamp';
  customData: Scalars['JSONObject'];
  discounts: Array<CartItemDiscount>;
  id: Scalars['ID'];
  name: Scalars['String'];
  originalPrice: Price;
  participant: Participant;
  paymentPrice?: Maybe<Price>;
  price: Price;
  profile: Scalars['String'];
  sku: Scalars['ID'];
};

export type CartItemWinterCamp = ICartItem & {
  __typename?: 'CartItemWinterCamp';
  customData: Scalars['JSONObject'];
  discounts: Array<CartItemDiscount>;
  id: Scalars['ID'];
  level: Scalars['String'];
  name: Scalars['String'];
  originalPrice: Price;
  participant: Participant;
  paymentPrice?: Maybe<Price>;
  price: Price;
  sku: Scalars['ID'];
  sport: Scalars['String'];
};

export type CartProblem = CartProblemCustomData | CartProblemMissingAccountData | CartProblemMissingChildData | CartProblemProductAgeRestriction | CartProblemProductOutOfStock | CartProblemProductPurchaseLimit | CartProblemRequiredProduct;

export type CartProblemCustomData = ICartProblem & {
  __typename?: 'CartProblemCustomData';
  code: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  item: CartItem;
  message: Scalars['String'];
  property: Scalars['String'];
  source: CartProblemSource;
};

export type CartProblemMissingAccountData = ICartProblem & {
  __typename?: 'CartProblemMissingAccountData';
  code: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  message: Scalars['String'];
  source: CartProblemSource;
};

export type CartProblemMissingChildData = ICartProblem & {
  __typename?: 'CartProblemMissingChildData';
  childId: Scalars['ID'];
  code: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  message: Scalars['String'];
  source: CartProblemSource;
};

export type CartProblemProductAgeRestriction = ICartProblem & {
  __typename?: 'CartProblemProductAgeRestriction';
  code: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  maximumBirthDate?: Maybe<Scalars['Date']>;
  message: Scalars['String'];
  minimumBirthDate?: Maybe<Scalars['Date']>;
  participantBirthDate: Scalars['Date'];
  participantId: Scalars['ID'];
  source: CartProblemSource;
};

export type CartProblemProductOutOfStock = ICartProblem & {
  __typename?: 'CartProblemProductOutOfStock';
  code: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  message: Scalars['String'];
  product: IProduct;
  source: CartProblemSource;
};

export type CartProblemProductPurchaseLimit = ICartProblem & {
  __typename?: 'CartProblemProductPurchaseLimit';
  code: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  message: Scalars['String'];
  product: IProduct;
  source: CartProblemSource;
};

export type CartProblemRequiredProduct = ICartProblem & {
  __typename?: 'CartProblemRequiredProduct';
  availableProducts: Array<IProduct>;
  code: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  message: Scalars['String'];
  source: CartProblemSource;
};

export enum CartProblemSource {
  Cart = 'CART',
  Group = 'GROUP',
  Item = 'ITEM'
}

export type Child = {
  __typename?: 'Child';
  address?: Maybe<Address>;
  availableProducts: Array<Product>;
  birthday?: Maybe<Scalars['Date']>;
  canDelete: Scalars['Boolean'];
  deletionBlockers?: Maybe<Array<ChildDeletionBlocker>>;
  health?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isIncomplete: Scalars['Boolean'];
  membership?: Maybe<Membership>;
  name?: Maybe<Scalars['String']>;
  pesel?: Maybe<Scalars['String']>;
  surname?: Maybe<Scalars['String']>;
};


export type ChildAvailableProductsArgs = {
  category: Scalars['String'];
  period?: InputMaybe<TimePeriodInput>;
};

/** Why a saved child profile cannot be deleted */
export enum ChildDeletionBlocker {
  OpenCart = 'OPEN_CART',
  OrderClosed = 'ORDER_CLOSED',
  OrderWaitingForPayment = 'ORDER_WAITING_FOR_PAYMENT',
  PurchaseHistory = 'PURCHASE_HISTORY'
}

export type ContactInfo = {
  __typename?: 'ContactInfo';
  email?: Maybe<Scalars['EmailAddress']>;
  phone?: Maybe<Scalars['PhoneNumber']>;
};

export type ContactInfoInput = {
  email?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
};

export type DiscountPercentage = {
  __typename?: 'DiscountPercentage';
  value: Scalars['NonNegativeFloat'];
};

export type Guardian = {
  __typename?: 'Guardian';
  contactInfo: ContactInfo;
  id: Scalars['ID'];
  name: Scalars['String'];
  surname: Scalars['String'];
};

export type IAdditionalPropertyField = {
  description?: Maybe<Scalars['String']>;
  displayName: Scalars['String'];
  name: Scalars['String'];
};

export type ICartItem = {
  customData: Scalars['JSONObject'];
  discounts: Array<CartItemDiscount>;
  id: Scalars['ID'];
  originalPrice: Price;
  price: Price;
  sku: Scalars['ID'];
};

export type ICartProblem = {
  code: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  message: Scalars['String'];
  source: CartProblemSource;
};

export type IProduct = {
  additionalProperties?: Maybe<Array<AdditionalPropertyField>>;
  categories: Array<ProductCategory>;
  category: ProductCategory;
  name: Scalars['String'];
  price: Price;
  sku: Scalars['ID'];
  stock?: Maybe<ProductStockInformation>;
};

export type Membership = {
  __typename?: 'Membership';
  end: Scalars['Date'];
  start: Scalars['Date'];
  type: MembershipType;
};

export type MembershipProduct = IProduct & {
  __typename?: 'MembershipProduct';
  additionalProperties?: Maybe<Array<AdditionalPropertyField>>;
  categories: Array<ProductCategory>;
  category: ProductCategory;
  kind: Scalars['String'];
  name: Scalars['String'];
  price: Price;
  sku: Scalars['ID'];
  stock?: Maybe<ProductStockInformation>;
};

export enum MembershipType {
  Premium = 'PREMIUM',
  Standard = 'STANDARD'
}

export type Mutation = {
  __typename?: 'Mutation';
  addChild: Account;
  addGuardian: Account;
  /** @deprecated Use cartAddItem or replace item */
  addMembershipCartItem: Cart;
  /** @deprecated Use cartAddItem */
  addWinterCampCartItem: Cart;
  cartAddDiscountCode: Cart;
  cartAddItem: Cart;
  cartItemUpdateCustomData: Cart;
  cartRemoveDiscountCode: Cart;
  cartRemoveItems: Cart;
  cartReplaceItem: Cart;
  generatePaymentLink: OrderPayment;
  placeOrder: Order;
  removeChild: Account;
  /** @deprecated Use cartRemoveItem */
  removeFromCart: Cart;
  removeGuardian: Account;
  updateAccount: Account;
  updateChild: Account;
  updateGuardian: Account;
};


export type MutationAddChildArgs = {
  input: AccountChildUpdateInput;
};


export type MutationAddGuardianArgs = {
  input: AccountGuardianUpdateInput;
};


export type MutationAddMembershipCartItemArgs = {
  accountId: Scalars['ID'];
  childId?: InputMaybe<Scalars['ID']>;
  input: CartItemMembershipInput;
};


export type MutationAddWinterCampCartItemArgs = {
  childId?: InputMaybe<Scalars['ID']>;
  input: WinterCampInput;
  sku: Scalars['ID'];
};


export type MutationCartAddDiscountCodeArgs = {
  code: Scalars['String'];
};


export type MutationCartAddItemArgs = {
  additionalData?: InputMaybe<Scalars['JSONObject']>;
  childId?: InputMaybe<Scalars['ID']>;
  sku: Scalars['ID'];
};


export type MutationCartItemUpdateCustomDataArgs = {
  input: Array<CartItemCustomDataInput>;
};


export type MutationCartRemoveDiscountCodeArgs = {
  code: Scalars['String'];
};


export type MutationCartRemoveItemsArgs = {
  items: Array<Scalars['ID']>;
};


export type MutationCartReplaceItemArgs = {
  additionalData?: InputMaybe<Scalars['JSONObject']>;
  childId?: InputMaybe<Scalars['ID']>;
  item: Scalars['ID'];
  sku: Scalars['ID'];
};


export type MutationGeneratePaymentLinkArgs = {
  orderId: Scalars['ID'];
  paymentId?: InputMaybe<Scalars['ID']>;
};


export type MutationPlaceOrderArgs = {
  input: OrderPlacementInput;
};


export type MutationRemoveChildArgs = {
  childId: Scalars['ID'];
};


export type MutationRemoveFromCartArgs = {
  itemIds: Array<Scalars['ID']>;
};


export type MutationRemoveGuardianArgs = {
  guardianId: Scalars['ID'];
};


export type MutationUpdateAccountArgs = {
  input: AccountUpdateInput;
};


export type MutationUpdateChildArgs = {
  accountId: Scalars['ID'];
  childId: Scalars['ID'];
  input: AccountChildUpdateInput;
};


export type MutationUpdateGuardianArgs = {
  guardianId: Scalars['ID'];
  input: AccountGuardianUpdateInput;
};

export type Order = {
  __typename?: 'Order';
  account: Account;
  date: Scalars['Date'];
  documents: Array<OrderDocument>;
  fullyPaid: Scalars['Boolean'];
  id: Scalars['ID'];
  items: Array<OrderItem>;
  itemsGroups: Array<OrderItemGroup>;
  paymentModel: Scalars['String'];
  payments: Array<OrderPayment>;
  price: Price;
  status: Scalars['String'];
};

export enum OrderDiscountSource {
  Cart = 'CART',
  Item = 'ITEM'
}

export enum OrderDiscountType {
  Percentage = 'PERCENTAGE',
  Value = 'VALUE'
}

export type OrderDiscountValue = DiscountPercentage | Price;

export type OrderDocument = {
  __typename?: 'OrderDocument';
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  link: Scalars['String'];
  name: Scalars['String'];
};

/**
 * OrderItem represents single product
 * - For memberships it is a single membership for a person (Account Or Child)
 * - For activity it is a repeatable activity with key identifiable properties:
 *   - sport
 *   - location
 *   - type
 *   - day
 *   - time
 */
export type OrderItem = OrderItemActivity | OrderItemMembership | OrderItemNewWinterCamp | OrderItemSummerCamp | OrderItemWinterCamp;

export type OrderItemActivity = {
  __typename?: 'OrderItemActivity';
  customData?: Maybe<Scalars['JSONObject']>;
  day: Scalars['String'];
  discounts: Array<OrderItemDiscount>;
  entries: Array<Scalars['Date']>;
  id: Scalars['ID'];
  location: Scalars['String'];
  participant: Participant;
  period: Period;
  price: Price;
  sku: Scalars['ID'];
  sport: Scalars['String'];
  time: Scalars['String'];
  type: Scalars['String'];
  unitPrice: Price;
};

export type OrderItemActivityBundle = {
  __typename?: 'OrderItemActivityBundle';
  dayTimes: Array<OrderItemActivityBundleDayTime>;
  discounts: Array<OrderItemDiscount>;
  entries: Array<Scalars['DateTime']>;
  location: Scalars['String'];
  participant: Participant;
  period: Period;
  price: Price;
  sport: Scalars['String'];
  type: Scalars['String'];
  unitPrice: Price;
};

export type OrderItemActivityBundleDayTime = {
  __typename?: 'OrderItemActivityBundleDayTime';
  day: Scalars['String'];
  time: Scalars['String'];
};

/**
 * OrderItemBundle contain memberships and bundles of activities.
 * Activity bundle is group of activities with the same:
 *   - sport
 *   - location
 *   - type
 */
export type OrderItemBundle = OrderItemActivityBundle | OrderItemMembership | OrderItemNewWinterCamp | OrderItemSummerCamp | OrderItemWinterCamp;

export type OrderItemDiscount = {
  __typename?: 'OrderItemDiscount';
  code: OrderDiscountType;
  discountValue: OrderDiscountValue;
  message: Scalars['String'];
  reason?: Maybe<Scalars['String']>;
  source: OrderDiscountSource;
};

/** OrderItemGroup groups OrderItem and OrderItemBundle for given participant. */
export type OrderItemGroup = {
  __typename?: 'OrderItemGroup';
  bundles: Array<OrderItemBundle>;
  items: Array<OrderItem>;
  participant: Participant;
};

export type OrderItemMembership = {
  __typename?: 'OrderItemMembership';
  customData?: Maybe<Scalars['JSONObject']>;
  discounts: Array<OrderItemDiscount>;
  end?: Maybe<Scalars['Date']>;
  id: Scalars['ID'];
  participant: Participant;
  period: Period;
  price: Price;
  sku: Scalars['ID'];
  start?: Maybe<Scalars['Date']>;
  type: MembershipType;
};

export type OrderItemNewWinterCamp = {
  __typename?: 'OrderItemNewWinterCamp';
  customData?: Maybe<Scalars['JSONObject']>;
  discounts: Array<OrderItemDiscount>;
  id: Scalars['ID'];
  name: Scalars['String'];
  participant: Participant;
  price: Price;
  profile: Scalars['String'];
  sku: Scalars['ID'];
};

export type OrderItemSummerCamp = {
  __typename?: 'OrderItemSummerCamp';
  customData?: Maybe<Scalars['JSONObject']>;
  discounts: Array<OrderItemDiscount>;
  id: Scalars['ID'];
  name: Scalars['String'];
  participant: Participant;
  price: Price;
  profile: Scalars['String'];
  sku: Scalars['ID'];
};

export type OrderItemWinterCamp = {
  __typename?: 'OrderItemWinterCamp';
  customData?: Maybe<Scalars['JSONObject']>;
  discounts: Array<OrderItemDiscount>;
  id: Scalars['ID'];
  level: Scalars['String'];
  name: Scalars['String'];
  participant: Participant;
  price: Price;
  sku: Scalars['ID'];
  sport: Scalars['String'];
};

export type OrderPayment = {
  __typename?: 'OrderPayment';
  dueDate?: Maybe<Scalars['Date']>;
  id: Scalars['ID'];
  link?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  price: Price;
  status: OrderPaymentStatus;
};

export enum OrderPaymentStatus {
  New = 'NEW',
  Paid = 'PAID',
  Pending = 'PENDING',
  Processing = 'PROCESSING'
}

export type OrderPlacementConsentsInput = {
  call: Scalars['Boolean'];
  email: Scalars['Boolean'];
  health: Scalars['Boolean'];
  healthProcessing: Scalars['Boolean'];
  knowledge: Scalars['Boolean'];
  text: Scalars['Boolean'];
};

export type OrderPlacementInput = {
  consents?: InputMaybe<OrderPlacementConsentsInput>;
  paymentOption: Scalars['ID'];
  /**
   * Consent to start the service before the 14 day withdrawal period ends (art. 15 of the consumer
   * rights act). Given per order, unlike account consents, and required to place an order.
   */
  serviceStartConsent?: InputMaybe<Scalars['Boolean']>;
  wantsInvoice?: InputMaybe<Scalars['Boolean']>;
};

export type OrdersSummary = {
  __typename?: 'OrdersSummary';
  active: Scalars['Int'];
  archive: Scalars['Int'];
  cart: Scalars['Boolean'];
};

export type Participant = Account | Child;

/** This should be a part of Payment service but for now it lives here */
export type PaymentOption = {
  __typename?: 'PaymentOption';
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  payments: Array<PaymentOptionItem>;
  price: Price;
};

export type PaymentOptionItem = {
  __typename?: 'PaymentOptionItem';
  bundles: Array<CartItemBundle>;
  dueDate?: Maybe<Scalars['Date']>;
  items: Array<CartItem>;
  name: Scalars['String'];
  price: Price;
};

export type Period = {
  __typename?: 'Period';
  end: Scalars['Date'];
  name: Scalars['String'];
  start: Scalars['Date'];
};

export type Price = {
  __typename?: 'Price';
  currency: Scalars['Currency'];
  value: Scalars['NonNegativeFloat'];
};

export type PriceOverrideField = {
  __typename?: 'PriceOverrideField';
  name: Scalars['String'];
  overrideType: PriceOverrideFieldType;
};

export enum PriceOverrideFieldType {
  Total = 'TOTAL',
  Unit = 'UNIT'
}

export type Product = ActivityProduct | BaseProduct | CampProduct | MembershipProduct;

export type ProductCategory = {
  __typename?: 'ProductCategory';
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type ProductStockInformation = {
  __typename?: 'ProductStockInformation';
  available: Scalars['Int'];
  total?: Maybe<Scalars['Int']>;
};

export type Query = {
  __typename?: 'Query';
  me: Account;
  products: Array<Product>;
};


export type QueryProductsArgs = {
  category: Scalars['String'];
  period?: InputMaybe<TimePeriodInput>;
};

export type TimePeriodInput = {
  end: Scalars['Date'];
  start: Scalars['Date'];
};

export type WinterCampInput = {
  level: Scalars['String'];
  sport: Scalars['String'];
};

export type UpdateMeMutationVariables = Exact<{
  input: AccountUpdateInput;
}>;


export type UpdateMeMutation = { __typename?: 'Mutation', updateAccount: { __typename?: 'Account', id: string, name?: string | undefined, surname?: string | undefined, pesel?: string | undefined, isIncomplete: boolean, contactInfo?: { __typename?: 'ContactInfo', email?: any | undefined, phone?: any | undefined } | undefined, address?: { __typename?: 'Address', street?: string | undefined, code?: string | undefined, city?: string | undefined } | undefined, consents: { __typename?: 'AccountConsents', knowledge?: boolean | undefined, health?: boolean | undefined, healthProcessing?: boolean | undefined, email?: boolean | undefined, text?: boolean | undefined, call?: boolean | undefined } } };

export type UpdateChildMutationVariables = Exact<{
  accountId: Scalars['ID'];
  childId: Scalars['ID'];
  input: AccountChildUpdateInput;
}>;


export type UpdateChildMutation = { __typename?: 'Mutation', updateChild: { __typename?: 'Account', id: string, children: Array<{ __typename?: 'Child', id: string, name?: string | undefined, surname?: string | undefined, health?: string | undefined, pesel?: string | undefined, birthday?: any | undefined, isIncomplete: boolean, address?: { __typename?: 'Address', street?: string | undefined, code?: string | undefined, city?: string | undefined } | undefined }> } };

export type AddChildMutationVariables = Exact<{
  input: AccountChildUpdateInput;
}>;


export type AddChildMutation = { __typename?: 'Mutation', addChild: { __typename?: 'Account', id: string, children: Array<{ __typename?: 'Child', id: string, name?: string | undefined, surname?: string | undefined, health?: string | undefined, pesel?: string | undefined, birthday?: any | undefined, isIncomplete: boolean, address?: { __typename?: 'Address', street?: string | undefined, code?: string | undefined, city?: string | undefined } | undefined }> } };

export type RemoveChildMutationVariables = Exact<{
  childId: Scalars['ID'];
}>;


export type RemoveChildMutation = { __typename?: 'Mutation', removeChild: { __typename?: 'Account', id: string, children: Array<{ __typename?: 'Child', id: string, name?: string | undefined, surname?: string | undefined, health?: string | undefined, pesel?: string | undefined, birthday?: any | undefined, isIncomplete: boolean, address?: { __typename?: 'Address', street?: string | undefined, code?: string | undefined, city?: string | undefined } | undefined }> } };

export type UpdateGuardianMutationVariables = Exact<{
  guardianId: Scalars['ID'];
  input: AccountGuardianUpdateInput;
}>;


export type UpdateGuardianMutation = { __typename?: 'Mutation', updateGuardian: { __typename?: 'Account', id: string, guardians: Array<{ __typename?: 'Guardian', id: string, name: string, surname: string, contactInfo: { __typename?: 'ContactInfo', email?: any | undefined, phone?: any | undefined } }> } };

export type AddGuardianMutationVariables = Exact<{
  input: AccountGuardianUpdateInput;
}>;


export type AddGuardianMutation = { __typename?: 'Mutation', addGuardian: { __typename?: 'Account', id: string, guardians: Array<{ __typename?: 'Guardian', id: string, name: string, surname: string, contactInfo: { __typename?: 'ContactInfo', email?: any | undefined, phone?: any | undefined } }> } };

export type RemoveGuardianMutationVariables = Exact<{
  guardianId: Scalars['ID'];
}>;


export type RemoveGuardianMutation = { __typename?: 'Mutation', removeGuardian: { __typename?: 'Account', id: string, guardians: Array<{ __typename?: 'Guardian', id: string, name: string, surname: string, contactInfo: { __typename?: 'ContactInfo', email?: any | undefined, phone?: any | undefined } }> } };

export type AddMembershipMutationVariables = Exact<{
  accountId: Scalars['ID'];
  childId?: InputMaybe<Scalars['ID']>;
  input: CartItemMembershipInput;
}>;


export type AddMembershipMutation = { __typename?: 'Mutation', addMembershipCartItem: { __typename?: 'Cart', id: string, paymentOptions: Array<{ __typename?: 'PaymentOption', id: string }>, items: Array<{ __typename?: 'CartItemActivity' } | { __typename?: 'CartItemMembership', price: { __typename?: 'Price', value: any }, participant: { __typename?: 'Account', name?: string | undefined } | { __typename?: 'Child', name?: string | undefined } } | { __typename?: 'CartItemNewWinterCamp' } | { __typename?: 'CartItemSummerCamp' } | { __typename?: 'CartItemWinterCamp' }> } };

export type PlaceOrderMutationVariables = Exact<{
  input: OrderPlacementInput;
}>;


export type PlaceOrderMutation = { __typename?: 'Mutation', placeOrder: { __typename?: 'Order', id: string, payments: Array<{ __typename?: 'OrderPayment', id: string, dueDate?: any | undefined, link?: string | undefined, status: OrderPaymentStatus, price: { __typename?: 'Price', value: any } }> } };

export type UpdateCustomDataMutationVariables = Exact<{
  itemId: Scalars['ID'];
  data: Scalars['JSONObject'];
}>;


export type UpdateCustomDataMutation = { __typename?: 'Mutation', cartItemUpdateCustomData: { __typename?: 'Cart', id: string, paymentOptions: Array<{ __typename?: 'PaymentOption', id: string, price: { __typename?: 'Price', value: any } }> } };

export type GeneratePaymentLinkMutationVariables = Exact<{
  orderId: Scalars['ID'];
  paymentId: Scalars['ID'];
}>;


export type GeneratePaymentLinkMutation = { __typename?: 'Mutation', generatePaymentLink: { __typename?: 'OrderPayment', link?: string | undefined } };

export type CartAddDiscountCodeMutationVariables = Exact<{
  code: Scalars['String'];
}>;


export type CartAddDiscountCodeMutation = { __typename?: 'Mutation', cartAddDiscountCode: { __typename?: 'Cart', id: string } };

export type CartRemoveDiscountCodeMutationVariables = Exact<{
  code: Scalars['String'];
}>;


export type CartRemoveDiscountCodeMutation = { __typename?: 'Mutation', cartRemoveDiscountCode: { __typename?: 'Cart', id: string } };

export type GetMeQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMeQuery = { __typename?: 'Query', me: { __typename?: 'Account', id: string, name?: string | undefined, surname?: string | undefined, pesel?: string | undefined, isIncomplete: boolean, contactInfo?: { __typename?: 'ContactInfo', email?: any | undefined, phone?: any | undefined } | undefined, address?: { __typename?: 'Address', street?: string | undefined, code?: string | undefined, city?: string | undefined } | undefined, consents: { __typename?: 'AccountConsents', knowledge?: boolean | undefined, health?: boolean | undefined, healthProcessing?: boolean | undefined, email?: boolean | undefined, text?: boolean | undefined, call?: boolean | undefined }, guardians: Array<{ __typename?: 'Guardian', id: string, name: string, surname: string, contactInfo: { __typename?: 'ContactInfo', email?: any | undefined, phone?: any | undefined } }> } };

export type GetMeIdQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMeIdQuery = { __typename?: 'Query', me: { __typename?: 'Account', id: string } };

export type GetChildrenQueryVariables = Exact<{ [key: string]: never; }>;


export type GetChildrenQuery = { __typename?: 'Query', me: { __typename?: 'Account', id: string, address?: { __typename?: 'Address', street?: string | undefined, code?: string | undefined, city?: string | undefined } | undefined, children: Array<{ __typename?: 'Child', id: string, name?: string | undefined, surname?: string | undefined, health?: string | undefined, pesel?: string | undefined, canDelete: boolean, deletionBlockers?: Array<ChildDeletionBlocker> | undefined, birthday?: any | undefined, isIncomplete: boolean, address?: { __typename?: 'Address', street?: string | undefined, code?: string | undefined, city?: string | undefined } | undefined, summer2026: Array<{ __typename?: 'ActivityProduct', sku: string, name: string, stock?: { __typename?: 'ProductStockInformation', available: number } | undefined, price: { __typename?: 'Price', value: any } } | { __typename?: 'BaseProduct', sku: string, name: string, stock?: { __typename?: 'ProductStockInformation', available: number } | undefined, price: { __typename?: 'Price', value: any } } | { __typename?: 'CampProduct', sku: string, name: string, stock?: { __typename?: 'ProductStockInformation', available: number } | undefined, price: { __typename?: 'Price', value: any } } | { __typename?: 'MembershipProduct', sku: string, name: string, stock?: { __typename?: 'ProductStockInformation', available: number } | undefined, price: { __typename?: 'Price', value: any } }>, adventure2025: Array<{ __typename?: 'ActivityProduct', sku: string, name: string, stock?: { __typename?: 'ProductStockInformation', available: number } | undefined, price: { __typename?: 'Price', value: any } } | { __typename?: 'BaseProduct', sku: string, name: string, stock?: { __typename?: 'ProductStockInformation', available: number } | undefined, price: { __typename?: 'Price', value: any } } | { __typename?: 'CampProduct', sku: string, name: string, stock?: { __typename?: 'ProductStockInformation', available: number } | undefined, price: { __typename?: 'Price', value: any } } | { __typename?: 'MembershipProduct', sku: string, name: string, stock?: { __typename?: 'ProductStockInformation', available: number } | undefined, price: { __typename?: 'Price', value: any } }>, master2025: Array<{ __typename?: 'ActivityProduct', sku: string, name: string, stock?: { __typename?: 'ProductStockInformation', available: number } | undefined, price: { __typename?: 'Price', value: any } } | { __typename?: 'BaseProduct', sku: string, name: string, stock?: { __typename?: 'ProductStockInformation', available: number } | undefined, price: { __typename?: 'Price', value: any } } | { __typename?: 'CampProduct', sku: string, name: string, stock?: { __typename?: 'ProductStockInformation', available: number } | undefined, price: { __typename?: 'Price', value: any } } | { __typename?: 'MembershipProduct', sku: string, name: string, stock?: { __typename?: 'ProductStockInformation', available: number } | undefined, price: { __typename?: 'Price', value: any } }> }> } };

export type GetWinterQueryVariables = Exact<{ [key: string]: never; }>;


export type GetWinterQuery = { __typename?: 'Query', me: { __typename?: 'Account', id: string, activeOrders: Array<{ __typename?: 'Order', id: string }>, children: Array<{ __typename?: 'Child', id: string, name?: string | undefined, surname?: string | undefined, isIncomplete: boolean, canDelete: boolean, availableProducts: Array<{ __typename?: 'ActivityProduct', name: string, sku: string, price: { __typename?: 'Price', currency: any, value: any }, stock?: { __typename?: 'ProductStockInformation', available: number, total?: number | undefined } | undefined } | { __typename?: 'BaseProduct', name: string, sku: string, price: { __typename?: 'Price', currency: any, value: any }, stock?: { __typename?: 'ProductStockInformation', available: number, total?: number | undefined } | undefined } | { __typename?: 'CampProduct', name: string, sku: string, price: { __typename?: 'Price', currency: any, value: any }, stock?: { __typename?: 'ProductStockInformation', available: number, total?: number | undefined } | undefined } | { __typename?: 'MembershipProduct', name: string, sku: string, price: { __typename?: 'Price', currency: any, value: any }, stock?: { __typename?: 'ProductStockInformation', available: number, total?: number | undefined } | undefined }> }> } };

export type GetOrdersQueryVariables = Exact<{ [key: string]: never; }>;


export type GetOrdersQuery = { __typename?: 'Query', me: { __typename?: 'Account', id: string, name?: string | undefined, surname?: string | undefined, isIncomplete: boolean, consents: { __typename?: 'AccountConsents', knowledge?: boolean | undefined, health?: boolean | undefined, healthProcessing?: boolean | undefined, email?: boolean | undefined, text?: boolean | undefined, call?: boolean | undefined }, cart?: { __typename?: 'Cart', discounts: Array<{ __typename?: 'CartDiscount', code: CartDiscountType, source: CartDiscountSource, reason?: string | undefined, message: string, discountValue: { __typename: 'DiscountPercentage', value: any } | { __typename: 'Price', value: any, currency: any } }>, discountCodes: Array<{ __typename?: 'CartDiscountCode', code: string, description: string, expirationDate?: any | undefined } | undefined>, paymentOptions: Array<{ __typename?: 'PaymentOption', id: string, name: string, description?: string | undefined, price: { __typename?: 'Price', value: any }, payments: Array<{ __typename?: 'PaymentOptionItem', name: string, dueDate?: any | undefined, price: { __typename?: 'Price', value: any }, items: Array<{ __typename: 'CartItemActivity', sport: string, location: string, type: string, entries: Array<any>, id: string, sku: string, customData: any, unitPrice: { __typename?: 'Price', value: any }, price: { __typename?: 'Price', value: any }, participant: { __typename: 'Account', id: string, name?: string | undefined, surname?: string | undefined, membership?: { __typename?: 'Membership', membershipType: MembershipType } | undefined } | { __typename: 'Child', id: string, name?: string | undefined, surname?: string | undefined, membership?: { __typename?: 'Membership', membershipType: MembershipType } | undefined } } | { __typename: 'CartItemMembership', start?: any | undefined, end?: any | undefined, id: string, sku: string, customData: any, membershipType: MembershipType, paymentPrice?: { __typename?: 'Price', value: any } | undefined, price: { __typename?: 'Price', value: any }, period: { __typename?: 'Period', start: any, end: any, name: string }, participant: { __typename: 'Account', id: string, name?: string | undefined, surname?: string | undefined } | { __typename: 'Child', id: string, name?: string | undefined, surname?: string | undefined } } | { __typename: 'CartItemNewWinterCamp', sku: string, id: string, name: string, customData: any, profile: string, paymentPrice?: { __typename?: 'Price', value: any } | undefined, price: { __typename?: 'Price', value: any }, participant: { __typename: 'Account', id: string, name?: string | undefined, surname?: string | undefined, membership?: { __typename?: 'Membership', membershipType: MembershipType } | undefined } | { __typename: 'Child', id: string, name?: string | undefined, surname?: string | undefined, membership?: { __typename?: 'Membership', membershipType: MembershipType } | undefined }, discounts: Array<{ __typename?: 'CartItemDiscount', source: CartDiscountSource, reason?: string | undefined, message: string, code: CartDiscountType, discountValue: { __typename: 'DiscountPercentage', value: any } | { __typename: 'Price', value: any, currency: any } }> } | { __typename: 'CartItemSummerCamp', sku: string, id: string, name: string, customData: any, profile: string, paymentPrice?: { __typename?: 'Price', value: any } | undefined, price: { __typename?: 'Price', value: any }, participant: { __typename: 'Account', id: string, name?: string | undefined, surname?: string | undefined, membership?: { __typename?: 'Membership', membershipType: MembershipType } | undefined } | { __typename: 'Child', id: string, name?: string | undefined, surname?: string | undefined, membership?: { __typename?: 'Membership', membershipType: MembershipType } | undefined }, discounts: Array<{ __typename?: 'CartItemDiscount', source: CartDiscountSource, reason?: string | undefined, message: string, code: CartDiscountType, discountValue: { __typename: 'DiscountPercentage', value: any } | { __typename: 'Price', value: any, currency: any } }> } | { __typename: 'CartItemWinterCamp', sport: string, sku: string, id: string, name: string, level: string, customData: any, paymentPrice?: { __typename?: 'Price', value: any } | undefined, price: { __typename?: 'Price', value: any }, participant: { __typename: 'Account', id: string, name?: string | undefined, surname?: string | undefined, membership?: { __typename?: 'Membership', membershipType: MembershipType } | undefined } | { __typename: 'Child', id: string, name?: string | undefined, surname?: string | undefined, membership?: { __typename?: 'Membership', membershipType: MembershipType } | undefined } }>, bundles: Array<{ __typename: 'CartItemActivityBundle', sport: string, location: string, type: string, entries: Array<any>, paymentPrice?: { __typename?: 'Price', value: any } | undefined, dayTimes: Array<{ __typename?: 'CartItemActivityBundleDayTime', day: string, time: string }>, price: { __typename?: 'Price', value: any }, unitPrice: { __typename?: 'Price', value: any }, period: { __typename?: 'Period', start: any, end: any, name: string }, participant: { __typename: 'Account', id: string, name?: string | undefined, surname?: string | undefined, membership?: { __typename?: 'Membership', membershipType: MembershipType } | undefined } | { __typename: 'Child', id: string, name?: string | undefined, surname?: string | undefined, membership?: { __typename?: 'Membership', membershipType: MembershipType } | undefined } } | { __typename: 'CartItemMembership', start?: any | undefined, end?: any | undefined, id: string, sku: string, customData: any, membershipType: MembershipType, paymentPrice?: { __typename?: 'Price', value: any } | undefined, price: { __typename?: 'Price', value: any }, period: { __typename?: 'Period', start: any, end: any, name: string }, participant: { __typename: 'Account', id: string, name?: string | undefined, surname?: string | undefined } | { __typename: 'Child', id: string, name?: string | undefined, surname?: string | undefined } } | { __typename: 'CartItemNewWinterCamp', sku: string, id: string, name: string, customData: any, profile: string, paymentPrice?: { __typename?: 'Price', value: any } | undefined, price: { __typename?: 'Price', value: any }, participant: { __typename: 'Account', id: string, name?: string | undefined, surname?: string | undefined, membership?: { __typename?: 'Membership', membershipType: MembershipType } | undefined } | { __typename: 'Child', id: string, name?: string | undefined, surname?: string | undefined, membership?: { __typename?: 'Membership', membershipType: MembershipType } | undefined }, discounts: Array<{ __typename?: 'CartItemDiscount', source: CartDiscountSource, reason?: string | undefined, message: string, code: CartDiscountType, discountValue: { __typename: 'DiscountPercentage', value: any } | { __typename: 'Price', value: any, currency: any } }> } | { __typename: 'CartItemSummerCamp', sku: string, id: string, name: string, customData: any, profile: string, paymentPrice?: { __typename?: 'Price', value: any } | undefined, price: { __typename?: 'Price', value: any }, participant: { __typename: 'Account', id: string, name?: string | undefined, surname?: string | undefined, membership?: { __typename?: 'Membership', membershipType: MembershipType } | undefined } | { __typename: 'Child', id: string, name?: string | undefined, surname?: string | undefined, membership?: { __typename?: 'Membership', membershipType: MembershipType } | undefined }, discounts: Array<{ __typename?: 'CartItemDiscount', source: CartDiscountSource, reason?: string | undefined, message: string, code: CartDiscountType, discountValue: { __typename: 'DiscountPercentage', value: any } | { __typename: 'Price', value: any, currency: any } }> } | { __typename: 'CartItemWinterCamp', sport: string, sku: string, id: string, name: string, level: string, customData: any, paymentPrice?: { __typename?: 'Price', value: any } | undefined, price: { __typename?: 'Price', value: any }, participant: { __typename: 'Account', id: string, name?: string | undefined, surname?: string | undefined, membership?: { __typename?: 'Membership', membershipType: MembershipType } | undefined } | { __typename: 'Child', id: string, name?: string | undefined, surname?: string | undefined, membership?: { __typename?: 'Membership', membershipType: MembershipType } | undefined } }> }> }>, itemsGroups: Array<{ __typename?: 'CartItemGroup', participant: { __typename: 'Account', id: string, name?: string | undefined, surname?: string | undefined, membership?: { __typename?: 'Membership', membershipType: MembershipType } | undefined } | { __typename: 'Child', id: string, name?: string | undefined, surname?: string | undefined, membership?: { __typename?: 'Membership', membershipType: MembershipType } | undefined }, bundles: Array<{ __typename: 'CartItemActivityBundle', sport: string, location: string, type: string, entries: Array<any>, paymentPrice?: { __typename?: 'Price', value: any } | undefined, dayTimes: Array<{ __typename?: 'CartItemActivityBundleDayTime', day: string, time: string }>, price: { __typename?: 'Price', value: any }, unitPrice: { __typename?: 'Price', value: any }, period: { __typename?: 'Period', start: any, end: any, name: string }, participant: { __typename: 'Account', id: string, name?: string | undefined, surname?: string | undefined, membership?: { __typename?: 'Membership', membershipType: MembershipType } | undefined } | { __typename: 'Child', id: string, name?: string | undefined, surname?: string | undefined, membership?: { __typename?: 'Membership', membershipType: MembershipType } | undefined } } | { __typename: 'CartItemMembership', start?: any | undefined, end?: any | undefined, id: string, sku: string, customData: any, membershipType: MembershipType, paymentPrice?: { __typename?: 'Price', value: any } | undefined, price: { __typename?: 'Price', value: any }, period: { __typename?: 'Period', start: any, end: any, name: string }, participant: { __typename: 'Account', id: string, name?: string | undefined, surname?: string | undefined } | { __typename: 'Child', id: string, name?: string | undefined, surname?: string | undefined } } | { __typename: 'CartItemNewWinterCamp', sku: string, id: string, name: string, customData: any, profile: string, paymentPrice?: { __typename?: 'Price', value: any } | undefined, price: { __typename?: 'Price', value: any }, participant: { __typename: 'Account', id: string, name?: string | undefined, surname?: string | undefined, membership?: { __typename?: 'Membership', membershipType: MembershipType } | undefined } | { __typename: 'Child', id: string, name?: string | undefined, surname?: string | undefined, membership?: { __typename?: 'Membership', membershipType: MembershipType } | undefined }, discounts: Array<{ __typename?: 'CartItemDiscount', source: CartDiscountSource, reason?: string | undefined, message: string, code: CartDiscountType, discountValue: { __typename: 'DiscountPercentage', value: any } | { __typename: 'Price', value: any, currency: any } }> } | { __typename: 'CartItemSummerCamp', sku: string, id: string, name: string, customData: any, profile: string, paymentPrice?: { __typename?: 'Price', value: any } | undefined, price: { __typename?: 'Price', value: any }, participant: { __typename: 'Account', id: string, name?: string | undefined, surname?: string | undefined, membership?: { __typename?: 'Membership', membershipType: MembershipType } | undefined } | { __typename: 'Child', id: string, name?: string | undefined, surname?: string | undefined, membership?: { __typename?: 'Membership', membershipType: MembershipType } | undefined }, discounts: Array<{ __typename?: 'CartItemDiscount', source: CartDiscountSource, reason?: string | undefined, message: string, code: CartDiscountType, discountValue: { __typename: 'DiscountPercentage', value: any } | { __typename: 'Price', value: any, currency: any } }> } | { __typename: 'CartItemWinterCamp', sport: string, sku: string, id: string, name: string, level: string, customData: any, paymentPrice?: { __typename?: 'Price', value: any } | undefined, price: { __typename?: 'Price', value: any }, participant: { __typename: 'Account', id: string, name?: string | undefined, surname?: string | undefined, membership?: { __typename?: 'Membership', membershipType: MembershipType } | undefined } | { __typename: 'Child', id: string, name?: string | undefined, surname?: string | undefined, membership?: { __typename?: 'Membership', membershipType: MembershipType } | undefined } }>, problems?: Array<{ __typename: 'CartProblemCustomData', property: string, code: string, description?: string | undefined, message: string, source: CartProblemSource, item: { __typename?: 'CartItemActivity', id: string, sku: string } | { __typename?: 'CartItemMembership', id: string, sku: string } | { __typename?: 'CartItemNewWinterCamp', id: string, sku: string } | { __typename?: 'CartItemSummerCamp', id: string, sku: string } | { __typename?: 'CartItemWinterCamp', id: string, sku: string } } | { __typename: 'CartProblemMissingAccountData', code: string, description?: string | undefined, message: string, source: CartProblemSource } | { __typename: 'CartProblemMissingChildData', childId: string, code: string, description?: string | undefined, message: string, source: CartProblemSource } | { __typename: 'CartProblemProductAgeRestriction', minimumBirthDate?: any | undefined, maximumBirthDate?: any | undefined, participantBirthDate: any, participantId: string, code: string, description?: string | undefined, message: string, source: CartProblemSource } | { __typename: 'CartProblemProductOutOfStock', code: string, description?: string | undefined, message: string, source: CartProblemSource, product: { __typename?: 'ActivityProduct', sku: string } | { __typename?: 'BaseProduct', sku: string } | { __typename?: 'CampProduct', sku: string } | { __typename?: 'MembershipProduct', sku: string } } | { __typename: 'CartProblemProductPurchaseLimit', code: string, description?: string | undefined, message: string, source: CartProblemSource } | { __typename: 'CartProblemRequiredProduct', code: string, description?: string | undefined, message: string, source: CartProblemSource, availableProducts: Array<{ __typename?: 'ActivityProduct', name: string, sku: string } | { __typename?: 'BaseProduct', name: string, sku: string } | { __typename?: 'CampProduct', name: string, sku: string } | { __typename?: 'MembershipProduct', name: string, sku: string }> }> | undefined }>, problems: Array<{ __typename: 'CartProblemCustomData', property: string, code: string, description?: string | undefined, message: string, source: CartProblemSource, item: { __typename?: 'CartItemActivity', id: string, sku: string } | { __typename?: 'CartItemMembership', id: string, sku: string } | { __typename?: 'CartItemNewWinterCamp', id: string, sku: string } | { __typename?: 'CartItemSummerCamp', id: string, sku: string } | { __typename?: 'CartItemWinterCamp', id: string, sku: string } } | { __typename: 'CartProblemMissingAccountData', code: string, description?: string | undefined, message: string, source: CartProblemSource } | { __typename: 'CartProblemMissingChildData', childId: string, code: string, description?: string | undefined, message: string, source: CartProblemSource } | { __typename: 'CartProblemProductAgeRestriction', minimumBirthDate?: any | undefined, maximumBirthDate?: any | undefined, participantBirthDate: any, participantId: string, code: string, description?: string | undefined, message: string, source: CartProblemSource } | { __typename: 'CartProblemProductOutOfStock', code: string, description?: string | undefined, message: string, source: CartProblemSource, product: { __typename?: 'ActivityProduct', sku: string } | { __typename?: 'BaseProduct', sku: string } | { __typename?: 'CampProduct', sku: string } | { __typename?: 'MembershipProduct', sku: string } } | { __typename: 'CartProblemProductPurchaseLimit', code: string, description?: string | undefined, message: string, source: CartProblemSource } | { __typename: 'CartProblemRequiredProduct', code: string, description?: string | undefined, message: string, source: CartProblemSource, availableProducts: Array<{ __typename?: 'ActivityProduct', name: string, sku: string } | { __typename?: 'BaseProduct', name: string, sku: string } | { __typename?: 'CampProduct', name: string, sku: string } | { __typename?: 'MembershipProduct', name: string, sku: string }> }> } | undefined } };

type CartProblemFragment_CartProblemCustomData_Fragment = { __typename: 'CartProblemCustomData', property: string, code: string, description?: string | undefined, message: string, source: CartProblemSource, item: { __typename?: 'CartItemActivity', id: string, sku: string } | { __typename?: 'CartItemMembership', id: string, sku: string } | { __typename?: 'CartItemNewWinterCamp', id: string, sku: string } | { __typename?: 'CartItemSummerCamp', id: string, sku: string } | { __typename?: 'CartItemWinterCamp', id: string, sku: string } };

type CartProblemFragment_CartProblemMissingAccountData_Fragment = { __typename: 'CartProblemMissingAccountData', code: string, description?: string | undefined, message: string, source: CartProblemSource };

type CartProblemFragment_CartProblemMissingChildData_Fragment = { __typename: 'CartProblemMissingChildData', childId: string, code: string, description?: string | undefined, message: string, source: CartProblemSource };

type CartProblemFragment_CartProblemProductAgeRestriction_Fragment = { __typename: 'CartProblemProductAgeRestriction', minimumBirthDate?: any | undefined, maximumBirthDate?: any | undefined, participantBirthDate: any, participantId: string, code: string, description?: string | undefined, message: string, source: CartProblemSource };

type CartProblemFragment_CartProblemProductOutOfStock_Fragment = { __typename: 'CartProblemProductOutOfStock', code: string, description?: string | undefined, message: string, source: CartProblemSource, product: { __typename?: 'ActivityProduct', sku: string } | { __typename?: 'BaseProduct', sku: string } | { __typename?: 'CampProduct', sku: string } | { __typename?: 'MembershipProduct', sku: string } };

type CartProblemFragment_CartProblemProductPurchaseLimit_Fragment = { __typename: 'CartProblemProductPurchaseLimit', code: string, description?: string | undefined, message: string, source: CartProblemSource };

type CartProblemFragment_CartProblemRequiredProduct_Fragment = { __typename: 'CartProblemRequiredProduct', code: string, description?: string | undefined, message: string, source: CartProblemSource, availableProducts: Array<{ __typename?: 'ActivityProduct', name: string, sku: string } | { __typename?: 'BaseProduct', name: string, sku: string } | { __typename?: 'CampProduct', name: string, sku: string } | { __typename?: 'MembershipProduct', name: string, sku: string }> };

export type CartProblemFragmentFragment = CartProblemFragment_CartProblemCustomData_Fragment | CartProblemFragment_CartProblemMissingAccountData_Fragment | CartProblemFragment_CartProblemMissingChildData_Fragment | CartProblemFragment_CartProblemProductAgeRestriction_Fragment | CartProblemFragment_CartProblemProductOutOfStock_Fragment | CartProblemFragment_CartProblemProductPurchaseLimit_Fragment | CartProblemFragment_CartProblemRequiredProduct_Fragment;

export type ActivityFragment = { __typename: 'CartItemActivity', sport: string, location: string, type: string, entries: Array<any>, id: string, sku: string, customData: any, unitPrice: { __typename?: 'Price', value: any }, price: { __typename?: 'Price', value: any }, participant: { __typename: 'Account', id: string, name?: string | undefined, surname?: string | undefined, membership?: { __typename?: 'Membership', membershipType: MembershipType } | undefined } | { __typename: 'Child', id: string, name?: string | undefined, surname?: string | undefined, membership?: { __typename?: 'Membership', membershipType: MembershipType } | undefined } };

export type MembershipFragment = { __typename: 'CartItemMembership', start?: any | undefined, end?: any | undefined, id: string, sku: string, customData: any, membershipType: MembershipType, paymentPrice?: { __typename?: 'Price', value: any } | undefined, price: { __typename?: 'Price', value: any }, period: { __typename?: 'Period', start: any, end: any, name: string }, participant: { __typename: 'Account', id: string, name?: string | undefined, surname?: string | undefined } | { __typename: 'Child', id: string, name?: string | undefined, surname?: string | undefined } };

export type WinterCampFragment = { __typename: 'CartItemWinterCamp', sport: string, sku: string, id: string, name: string, level: string, customData: any, paymentPrice?: { __typename?: 'Price', value: any } | undefined, price: { __typename?: 'Price', value: any }, participant: { __typename: 'Account', id: string, name?: string | undefined, surname?: string | undefined, membership?: { __typename?: 'Membership', membershipType: MembershipType } | undefined } | { __typename: 'Child', id: string, name?: string | undefined, surname?: string | undefined, membership?: { __typename?: 'Membership', membershipType: MembershipType } | undefined } };

export type SummerCampFragment = { __typename: 'CartItemSummerCamp', sku: string, id: string, name: string, customData: any, profile: string, paymentPrice?: { __typename?: 'Price', value: any } | undefined, price: { __typename?: 'Price', value: any }, participant: { __typename: 'Account', id: string, name?: string | undefined, surname?: string | undefined, membership?: { __typename?: 'Membership', membershipType: MembershipType } | undefined } | { __typename: 'Child', id: string, name?: string | undefined, surname?: string | undefined, membership?: { __typename?: 'Membership', membershipType: MembershipType } | undefined }, discounts: Array<{ __typename?: 'CartItemDiscount', source: CartDiscountSource, reason?: string | undefined, message: string, code: CartDiscountType, discountValue: { __typename: 'DiscountPercentage', value: any } | { __typename: 'Price', value: any, currency: any } }> };

export type NewWinterCampFragment = { __typename: 'CartItemNewWinterCamp', sku: string, id: string, name: string, customData: any, profile: string, paymentPrice?: { __typename?: 'Price', value: any } | undefined, price: { __typename?: 'Price', value: any }, participant: { __typename: 'Account', id: string, name?: string | undefined, surname?: string | undefined, membership?: { __typename?: 'Membership', membershipType: MembershipType } | undefined } | { __typename: 'Child', id: string, name?: string | undefined, surname?: string | undefined, membership?: { __typename?: 'Membership', membershipType: MembershipType } | undefined }, discounts: Array<{ __typename?: 'CartItemDiscount', source: CartDiscountSource, reason?: string | undefined, message: string, code: CartDiscountType, discountValue: { __typename: 'DiscountPercentage', value: any } | { __typename: 'Price', value: any, currency: any } }> };

export type ActivityBundleFragment = { __typename: 'CartItemActivityBundle', sport: string, location: string, type: string, entries: Array<any>, paymentPrice?: { __typename?: 'Price', value: any } | undefined, dayTimes: Array<{ __typename?: 'CartItemActivityBundleDayTime', day: string, time: string }>, price: { __typename?: 'Price', value: any }, unitPrice: { __typename?: 'Price', value: any }, period: { __typename?: 'Period', start: any, end: any, name: string }, participant: { __typename: 'Account', id: string, name?: string | undefined, surname?: string | undefined, membership?: { __typename?: 'Membership', membershipType: MembershipType } | undefined } | { __typename: 'Child', id: string, name?: string | undefined, surname?: string | undefined, membership?: { __typename?: 'Membership', membershipType: MembershipType } | undefined } };

export type GetPaymentOptionIdQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPaymentOptionIdQuery = { __typename?: 'Query', me: { __typename?: 'Account', id: string, cart?: { __typename?: 'Cart', paymentOptions: Array<{ __typename?: 'PaymentOption', id: string, price: { __typename?: 'Price', value: any } }> } | undefined } };

export type GetActiveOrdersQueryVariables = Exact<{ [key: string]: never; }>;


export type GetActiveOrdersQuery = { __typename?: 'Query', me: { __typename?: 'Account', id: string, activeOrders: Array<{ __typename?: 'Order', id: string, date: any, fullyPaid: boolean, documents: Array<{ __typename?: 'OrderDocument', id: string, name: string, description?: string | undefined, link: string }>, price: { __typename?: 'Price', value: any }, payments: Array<{ __typename?: 'OrderPayment', id: string, name: string, dueDate?: any | undefined, status: OrderPaymentStatus, link?: string | undefined, price: { __typename?: 'Price', value: any } }>, itemsGroups: Array<{ __typename?: 'OrderItemGroup', participant: { __typename: 'Account', id: string, name?: string | undefined, surname?: string | undefined, membership?: { __typename?: 'Membership', membershipType: MembershipType } | undefined } | { __typename: 'Child', id: string, name?: string | undefined, surname?: string | undefined, membership?: { __typename?: 'Membership', membershipType: MembershipType } | undefined }, bundles: Array<{ __typename: 'OrderItemActivityBundle', sport: string, location: string, type: string, entries: Array<any>, dayTimes: Array<{ __typename?: 'OrderItemActivityBundleDayTime', day: string, time: string }>, unitPrice: { __typename?: 'Price', value: any }, price: { __typename?: 'Price', value: any }, period: { __typename?: 'Period', start: any, end: any, name: string } } | { __typename: 'OrderItemMembership', membershipType: MembershipType, price: { __typename?: 'Price', value: any }, period: { __typename?: 'Period', start: any, end: any, name: string } } | { __typename: 'OrderItemNewWinterCamp', sku: string, name: string, profile: string, price: { __typename?: 'Price', value: any }, discounts: Array<{ __typename?: 'OrderItemDiscount', reason?: string | undefined, source: OrderDiscountSource, message: string, discountValue: { __typename?: 'DiscountPercentage', percentage: any } | { __typename?: 'Price', value: any } }>, participant: { __typename: 'Account', id: string, name?: string | undefined, surname?: string | undefined, membership?: { __typename?: 'Membership', membershipType: MembershipType } | undefined } | { __typename: 'Child', id: string, name?: string | undefined, surname?: string | undefined, membership?: { __typename?: 'Membership', membershipType: MembershipType } | undefined } } | { __typename: 'OrderItemSummerCamp', sku: string, name: string, profile: string, price: { __typename?: 'Price', value: any }, discounts: Array<{ __typename?: 'OrderItemDiscount', reason?: string | undefined, source: OrderDiscountSource, message: string, discountValue: { __typename?: 'DiscountPercentage', percentage: any } | { __typename?: 'Price', value: any } }>, participant: { __typename: 'Account', id: string, name?: string | undefined, surname?: string | undefined, membership?: { __typename?: 'Membership', membershipType: MembershipType } | undefined } | { __typename: 'Child', id: string, name?: string | undefined, surname?: string | undefined, membership?: { __typename?: 'Membership', membershipType: MembershipType } | undefined } } | { __typename: 'OrderItemWinterCamp', sku: string, name: string, sport: string, level: string, price: { __typename?: 'Price', value: any }, discounts: Array<{ __typename?: 'OrderItemDiscount', reason?: string | undefined, source: OrderDiscountSource, message: string, discountValue: { __typename?: 'DiscountPercentage', percentage: any } | { __typename?: 'Price', value: any } }>, participant: { __typename: 'Account', id: string, name?: string | undefined, surname?: string | undefined, membership?: { __typename?: 'Membership', membershipType: MembershipType } | undefined } | { __typename: 'Child', id: string, name?: string | undefined, surname?: string | undefined, membership?: { __typename?: 'Membership', membershipType: MembershipType } | undefined } }> }> }> } };

export type GetArchiveOrdersQueryVariables = Exact<{ [key: string]: never; }>;


export type GetArchiveOrdersQuery = { __typename?: 'Query', me: { __typename?: 'Account', id: string, archiveOrders: Array<{ __typename?: 'Order', id: string, date: any, fullyPaid: boolean, price: { __typename?: 'Price', value: any }, documents: Array<{ __typename?: 'OrderDocument', id: string, name: string, description?: string | undefined, link: string }>, payments: Array<{ __typename?: 'OrderPayment', id: string, name: string, dueDate?: any | undefined, status: OrderPaymentStatus, link?: string | undefined, price: { __typename?: 'Price', value: any } }>, itemsGroups: Array<{ __typename?: 'OrderItemGroup', participant: { __typename: 'Account', id: string, name?: string | undefined, surname?: string | undefined, membership?: { __typename?: 'Membership', membershipType: MembershipType } | undefined } | { __typename: 'Child', id: string, name?: string | undefined, surname?: string | undefined, membership?: { __typename?: 'Membership', membershipType: MembershipType } | undefined }, bundles: Array<{ __typename: 'OrderItemActivityBundle', sport: string, location: string, type: string, entries: Array<any>, dayTimes: Array<{ __typename?: 'OrderItemActivityBundleDayTime', day: string, time: string }>, unitPrice: { __typename?: 'Price', value: any }, price: { __typename?: 'Price', value: any }, period: { __typename?: 'Period', start: any, end: any, name: string } } | { __typename: 'OrderItemMembership', membershipType: MembershipType, price: { __typename?: 'Price', value: any }, period: { __typename?: 'Period', start: any, end: any, name: string } } | { __typename: 'OrderItemNewWinterCamp', sku: string, name: string, profile: string, price: { __typename?: 'Price', value: any }, discounts: Array<{ __typename?: 'OrderItemDiscount', reason?: string | undefined, source: OrderDiscountSource, message: string, discountValue: { __typename?: 'DiscountPercentage', percentage: any } | { __typename?: 'Price', value: any } }>, participant: { __typename: 'Account', id: string, name?: string | undefined, surname?: string | undefined, membership?: { __typename?: 'Membership', membershipType: MembershipType } | undefined } | { __typename: 'Child', id: string, name?: string | undefined, surname?: string | undefined, membership?: { __typename?: 'Membership', membershipType: MembershipType } | undefined } } | { __typename: 'OrderItemSummerCamp', sku: string, name: string, profile: string, price: { __typename?: 'Price', value: any }, discounts: Array<{ __typename?: 'OrderItemDiscount', reason?: string | undefined, source: OrderDiscountSource, message: string, discountValue: { __typename?: 'DiscountPercentage', percentage: any } | { __typename?: 'Price', value: any } }>, participant: { __typename: 'Account', id: string, name?: string | undefined, surname?: string | undefined, membership?: { __typename?: 'Membership', membershipType: MembershipType } | undefined } | { __typename: 'Child', id: string, name?: string | undefined, surname?: string | undefined, membership?: { __typename?: 'Membership', membershipType: MembershipType } | undefined } } | { __typename: 'OrderItemWinterCamp' }> }> }> } };

export type GetOrdersSummaryQueryVariables = Exact<{ [key: string]: never; }>;


export type GetOrdersSummaryQuery = { __typename?: 'Query', me: { __typename?: 'Account', ordersSummary: { __typename?: 'OrdersSummary', cart: boolean, active: number, archive: number } } };

export type GetAllActivitiesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllActivitiesQuery = { __typename?: 'Query', me: { __typename?: 'Account', id: string, allActivities: Array<{ __typename?: 'OrderItemGroup', participant: { __typename: 'Account', id: string, name?: string | undefined, surname?: string | undefined, membership?: { __typename?: 'Membership', membershipType: MembershipType } | undefined } | { __typename: 'Child', id: string, name?: string | undefined, surname?: string | undefined, membership?: { __typename?: 'Membership', membershipType: MembershipType } | undefined }, bundles: Array<{ __typename: 'OrderItemActivityBundle', sport: string, location: string, type: string, entries: Array<any>, dayTimes: Array<{ __typename?: 'OrderItemActivityBundleDayTime', day: string, time: string }>, unitPrice: { __typename?: 'Price', value: any }, price: { __typename?: 'Price', value: any } } | { __typename: 'OrderItemMembership', membershipType: MembershipType, price: { __typename?: 'Price', value: any } } | { __typename: 'OrderItemNewWinterCamp' } | { __typename: 'OrderItemSummerCamp' } | { __typename: 'OrderItemWinterCamp' }> }> } };

export type GetSummerCamps2026QueryVariables = Exact<{ [key: string]: never; }>;


export type GetSummerCamps2026Query = { __typename?: 'Query', summer2026: Array<{ __typename?: 'ActivityProduct', sku: string, name: string, stock?: { __typename?: 'ProductStockInformation', available: number } | undefined } | { __typename?: 'BaseProduct', sku: string, name: string, stock?: { __typename?: 'ProductStockInformation', available: number } | undefined } | { __typename?: 'CampProduct', sku: string, name: string, stock?: { __typename?: 'ProductStockInformation', available: number } | undefined } | { __typename?: 'MembershipProduct', sku: string, name: string, stock?: { __typename?: 'ProductStockInformation', available: number } | undefined }> };

export type GetWinterCamps2027QueryVariables = Exact<{ [key: string]: never; }>;


export type GetWinterCamps2027Query = { __typename?: 'Query', winter2027: Array<{ __typename?: 'ActivityProduct', sku: string, name: string, stock?: { __typename?: 'ProductStockInformation', available: number } | undefined } | { __typename?: 'BaseProduct', sku: string, name: string, stock?: { __typename?: 'ProductStockInformation', available: number } | undefined } | { __typename?: 'CampProduct', sku: string, name: string, stock?: { __typename?: 'ProductStockInformation', available: number } | undefined } | { __typename?: 'MembershipProduct', sku: string, name: string, stock?: { __typename?: 'ProductStockInformation', available: number } | undefined }> };

export type GetNewWinterCamps2025QueryVariables = Exact<{ [key: string]: never; }>;


export type GetNewWinterCamps2025Query = { __typename?: 'Query', adventure2025: Array<{ __typename?: 'ActivityProduct', sku: string, name: string, stock?: { __typename?: 'ProductStockInformation', available: number } | undefined } | { __typename?: 'BaseProduct', sku: string, name: string, stock?: { __typename?: 'ProductStockInformation', available: number } | undefined } | { __typename?: 'CampProduct', sku: string, name: string, stock?: { __typename?: 'ProductStockInformation', available: number } | undefined } | { __typename?: 'MembershipProduct', sku: string, name: string, stock?: { __typename?: 'ProductStockInformation', available: number } | undefined }>, master2025: Array<{ __typename?: 'ActivityProduct', sku: string, name: string, stock?: { __typename?: 'ProductStockInformation', available: number } | undefined } | { __typename?: 'BaseProduct', sku: string, name: string, stock?: { __typename?: 'ProductStockInformation', available: number } | undefined } | { __typename?: 'CampProduct', sku: string, name: string, stock?: { __typename?: 'ProductStockInformation', available: number } | undefined } | { __typename?: 'MembershipProduct', sku: string, name: string, stock?: { __typename?: 'ProductStockInformation', available: number } | undefined }> };

export type GetConsentsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetConsentsQuery = { __typename?: 'Query', me: { __typename?: 'Account', consents: { __typename?: 'AccountConsents', call?: boolean | undefined, email?: boolean | undefined, health?: boolean | undefined, healthProcessing?: boolean | undefined, knowledge?: boolean | undefined, text?: boolean | undefined } } };

export type GetCartItemGroupsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCartItemGroupsQuery = { __typename?: 'Query', me: { __typename?: 'Account', id: string, isIncomplete: boolean, cart?: { __typename?: 'Cart', id: string, itemsGroups: Array<{ __typename?: 'CartItemGroup', participant: { __typename?: 'Account', id: string } | { __typename?: 'Child', id: string } }> } | undefined } };

export type GetErrorQueryVariables = Exact<{ [key: string]: never; }>;


export type GetErrorQuery = { __typename?: 'Query', me: { __typename?: 'Account', id: string } };

export type GetSummerCamps2026FromChildQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSummerCamps2026FromChildQuery = { __typename?: 'Query', me: { __typename?: 'Account', id: string, children: Array<{ __typename?: 'Child', id: string, name?: string | undefined, surname?: string | undefined, summer2026: Array<{ __typename?: 'ActivityProduct', sku: string, name: string, stock?: { __typename?: 'ProductStockInformation', available: number } | undefined, price: { __typename?: 'Price', value: any } } | { __typename?: 'BaseProduct', sku: string, name: string, stock?: { __typename?: 'ProductStockInformation', available: number } | undefined, price: { __typename?: 'Price', value: any } } | { __typename?: 'CampProduct', sku: string, name: string, stock?: { __typename?: 'ProductStockInformation', available: number } | undefined, price: { __typename?: 'Price', value: any } } | { __typename?: 'MembershipProduct', sku: string, name: string, stock?: { __typename?: 'ProductStockInformation', available: number } | undefined, price: { __typename?: 'Price', value: any } }> }> } };

export type AddToCartSummerCampMutationVariables = Exact<{
  sku: Scalars['ID'];
  childId: Scalars['ID'];
}>;


export type AddToCartSummerCampMutation = { __typename?: 'Mutation', cartAddItem: { __typename?: 'Cart', id: string, problems: Array<{ __typename?: 'CartProblemCustomData', code: string, message: string, property: string, item: { __typename?: 'CartItemActivity', id: string, sku: string } | { __typename?: 'CartItemMembership', id: string, sku: string } | { __typename?: 'CartItemNewWinterCamp', id: string, sku: string } | { __typename?: 'CartItemSummerCamp', id: string, sku: string } | { __typename?: 'CartItemWinterCamp', id: string, sku: string } } | { __typename?: 'CartProblemMissingAccountData', code: string, message: string } | { __typename?: 'CartProblemMissingChildData', code: string, message: string } | { __typename?: 'CartProblemProductAgeRestriction', code: string, message: string } | { __typename?: 'CartProblemProductOutOfStock', code: string, message: string } | { __typename?: 'CartProblemProductPurchaseLimit', code: string, message: string } | { __typename?: 'CartProblemRequiredProduct', code: string, message: string }>, items: Array<{ __typename?: 'CartItemActivity' } | { __typename?: 'CartItemMembership' } | { __typename?: 'CartItemNewWinterCamp' } | { __typename?: 'CartItemSummerCamp', sku: string, id: string } | { __typename?: 'CartItemWinterCamp' }> } };

export type GetNewWinterCamps2025FromChildQueryVariables = Exact<{ [key: string]: never; }>;


export type GetNewWinterCamps2025FromChildQuery = { __typename?: 'Query', me: { __typename?: 'Account', id: string, children: Array<{ __typename?: 'Child', id: string, name?: string | undefined, surname?: string | undefined, adventure2025: Array<{ __typename?: 'ActivityProduct', sku: string, name: string, stock?: { __typename?: 'ProductStockInformation', available: number } | undefined, price: { __typename?: 'Price', value: any } } | { __typename?: 'BaseProduct', sku: string, name: string, stock?: { __typename?: 'ProductStockInformation', available: number } | undefined, price: { __typename?: 'Price', value: any } } | { __typename?: 'CampProduct', sku: string, name: string, stock?: { __typename?: 'ProductStockInformation', available: number } | undefined, price: { __typename?: 'Price', value: any } } | { __typename?: 'MembershipProduct', sku: string, name: string, stock?: { __typename?: 'ProductStockInformation', available: number } | undefined, price: { __typename?: 'Price', value: any } }>, master2025: Array<{ __typename?: 'ActivityProduct', sku: string, name: string, stock?: { __typename?: 'ProductStockInformation', available: number } | undefined, price: { __typename?: 'Price', value: any } } | { __typename?: 'BaseProduct', sku: string, name: string, stock?: { __typename?: 'ProductStockInformation', available: number } | undefined, price: { __typename?: 'Price', value: any } } | { __typename?: 'CampProduct', sku: string, name: string, stock?: { __typename?: 'ProductStockInformation', available: number } | undefined, price: { __typename?: 'Price', value: any } } | { __typename?: 'MembershipProduct', sku: string, name: string, stock?: { __typename?: 'ProductStockInformation', available: number } | undefined, price: { __typename?: 'Price', value: any } }> }> } };

export type AddToCartMutationVariables = Exact<{
  sku: Scalars['ID'];
  childId: Scalars['ID'];
}>;


export type AddToCartMutation = { __typename?: 'Mutation', cartAddItem: { __typename?: 'Cart', id: string, problems: Array<{ __typename?: 'CartProblemCustomData', code: string, message: string, property: string, item: { __typename?: 'CartItemActivity', id: string, sku: string } | { __typename?: 'CartItemMembership', id: string, sku: string } | { __typename?: 'CartItemNewWinterCamp', id: string, sku: string } | { __typename?: 'CartItemSummerCamp', id: string, sku: string } | { __typename?: 'CartItemWinterCamp', id: string, sku: string } } | { __typename?: 'CartProblemMissingAccountData', code: string, message: string } | { __typename?: 'CartProblemMissingChildData', code: string, message: string } | { __typename?: 'CartProblemProductAgeRestriction', code: string, message: string } | { __typename?: 'CartProblemProductOutOfStock', code: string, message: string } | { __typename?: 'CartProblemProductPurchaseLimit', code: string, message: string } | { __typename?: 'CartProblemRequiredProduct', code: string, message: string }>, items: Array<{ __typename?: 'CartItemActivity' } | { __typename?: 'CartItemMembership' } | { __typename?: 'CartItemNewWinterCamp', sku: string, id: string } | { __typename?: 'CartItemSummerCamp' } | { __typename?: 'CartItemWinterCamp' }> } };

export type GetWinterCamps2027FromChildQueryVariables = Exact<{ [key: string]: never; }>;


export type GetWinterCamps2027FromChildQuery = { __typename?: 'Query', me: { __typename?: 'Account', id: string, children: Array<{ __typename?: 'Child', id: string, name?: string | undefined, surname?: string | undefined, winter2027: Array<{ __typename?: 'ActivityProduct', sku: string, name: string, stock?: { __typename?: 'ProductStockInformation', available: number } | undefined, price: { __typename?: 'Price', value: any } } | { __typename?: 'BaseProduct', sku: string, name: string, stock?: { __typename?: 'ProductStockInformation', available: number } | undefined, price: { __typename?: 'Price', value: any } } | { __typename?: 'CampProduct', sku: string, name: string, stock?: { __typename?: 'ProductStockInformation', available: number } | undefined, price: { __typename?: 'Price', value: any } } | { __typename?: 'MembershipProduct', sku: string, name: string, stock?: { __typename?: 'ProductStockInformation', available: number } | undefined, price: { __typename?: 'Price', value: any } }> }> } };

export type AddToCartWinterCamp2027MutationVariables = Exact<{
  sku: Scalars['ID'];
  childId: Scalars['ID'];
}>;


export type AddToCartWinterCamp2027Mutation = { __typename?: 'Mutation', cartAddItem: { __typename?: 'Cart', id: string, problems: Array<{ __typename?: 'CartProblemCustomData', code: string, message: string, property: string, item: { __typename?: 'CartItemActivity', id: string, sku: string } | { __typename?: 'CartItemMembership', id: string, sku: string } | { __typename?: 'CartItemNewWinterCamp', id: string, sku: string } | { __typename?: 'CartItemSummerCamp', id: string, sku: string } | { __typename?: 'CartItemWinterCamp', id: string, sku: string } } | { __typename?: 'CartProblemMissingAccountData', code: string, message: string } | { __typename?: 'CartProblemMissingChildData', code: string, message: string } | { __typename?: 'CartProblemProductAgeRestriction', code: string, message: string } | { __typename?: 'CartProblemProductOutOfStock', code: string, message: string } | { __typename?: 'CartProblemProductPurchaseLimit', code: string, message: string } | { __typename?: 'CartProblemRequiredProduct', code: string, message: string }>, items: Array<{ __typename?: 'CartItemActivity' } | { __typename?: 'CartItemMembership' } | { __typename?: 'CartItemNewWinterCamp', sku: string, id: string } | { __typename?: 'CartItemSummerCamp' } | { __typename?: 'CartItemWinterCamp' }> } };

export const CartProblemFragment = gql`
    fragment CartProblemFragment on ICartProblem {
  __typename
  code
  description
  message
  source
  ... on CartProblemRequiredProduct {
    availableProducts {
      name
      sku
    }
  }
  ... on CartProblemMissingChildData {
    childId
  }
  ... on CartProblemProductOutOfStock {
    product {
      sku
    }
  }
  ... on CartProblemProductAgeRestriction {
    minimumBirthDate
    maximumBirthDate
    participantBirthDate
    participantId
  }
  ... on CartProblemCustomData {
    item {
      ... on ICartItem {
        id
        sku
      }
    }
    property
  }
}
    `;
export const Activity = gql`
    fragment Activity on CartItemActivity {
  __typename
  sport
  location
  type
  entries
  id
  sku
  customData
  unitPrice {
    value
  }
  price {
    value
  }
  participant {
    ... on Child {
      __typename
      id
      name
      surname
      membership {
        membershipType: type
      }
    }
    ... on Account {
      __typename
      id
      name
      surname
      membership {
        membershipType: type
      }
    }
  }
}
    `;
export const Membership = gql`
    fragment Membership on CartItemMembership {
  paymentPrice {
    value
  }
  __typename
  membershipType: type
  start
  end
  id
  sku
  customData
  price {
    value
  }
  period {
    start
    end
    name
  }
  participant {
    ... on Child {
      __typename
      id
      name
      surname
    }
    ... on Account {
      __typename
      id
      name
      surname
    }
  }
}
    `;
export const WinterCamp = gql`
    fragment WinterCamp on CartItemWinterCamp {
  paymentPrice {
    value
  }
  __typename
  sport
  sku
  id
  name
  level
  customData
  price {
    value
  }
  participant {
    ... on Child {
      __typename
      id
      name
      surname
      membership {
        membershipType: type
      }
    }
    ... on Account {
      __typename
      id
      name
      surname
      membership {
        membershipType: type
      }
    }
  }
}
    `;
export const SummerCamp = gql`
    fragment SummerCamp on CartItemSummerCamp {
  paymentPrice {
    value
  }
  __typename
  sku
  id
  name
  customData
  price {
    value
  }
  profile
  participant {
    ... on Child {
      __typename
      id
      name
      surname
      membership {
        membershipType: type
      }
    }
    ... on Account {
      __typename
      id
      name
      surname
      membership {
        membershipType: type
      }
    }
  }
  discounts {
    source
    reason
    message
    code
    discountValue {
      __typename
      ... on DiscountPercentage {
        value
      }
      ... on Price {
        value
        currency
      }
    }
  }
}
    `;
export const NewWinterCamp = gql`
    fragment NewWinterCamp on CartItemNewWinterCamp {
  paymentPrice {
    value
  }
  __typename
  sku
  id
  name
  customData
  price {
    value
  }
  profile
  participant {
    ... on Child {
      __typename
      id
      name
      surname
      membership {
        membershipType: type
      }
    }
    ... on Account {
      __typename
      id
      name
      surname
      membership {
        membershipType: type
      }
    }
  }
  discounts {
    source
    reason
    message
    code
    discountValue {
      __typename
      ... on DiscountPercentage {
        value
      }
      ... on Price {
        value
        currency
      }
    }
  }
}
    `;
export const ActivityBundle = gql`
    fragment ActivityBundle on CartItemActivityBundle {
  paymentPrice {
    value
  }
  __typename
  sport
  location
  type
  entries
  dayTimes {
    day
    time
  }
  price {
    value
  }
  unitPrice {
    value
  }
  period {
    start
    end
    name
  }
  participant {
    ... on Child {
      __typename
      id
      name
      surname
      membership {
        membershipType: type
      }
    }
    ... on Account {
      __typename
      id
      name
      surname
      membership {
        membershipType: type
      }
    }
  }
}
    `;
export const UpdateMe = gql`
    mutation UpdateMe($input: AccountUpdateInput!) {
  updateAccount(input: $input) {
    id
    name
    surname
    contactInfo {
      email
      phone
    }
    pesel
    address {
      street
      code
      city
    }
    isIncomplete
    consents {
      knowledge
      health
      healthProcessing
      email
      text
      call
    }
  }
}
    `;
export const UpdateChild = gql`
    mutation UpdateChild($accountId: ID!, $childId: ID!, $input: AccountChildUpdateInput!) {
  updateChild(accountId: $accountId, childId: $childId, input: $input) {
    id
    children {
      id
      name
      surname
      health
      pesel
      address {
        street
        code
        city
      }
      birthday
      isIncomplete
    }
  }
}
    `;
export const AddChild = gql`
    mutation AddChild($input: AccountChildUpdateInput!) {
  addChild(input: $input) {
    id
    children {
      id
      name
      surname
      health
      pesel
      address {
        street
        code
        city
      }
      birthday
      isIncomplete
    }
  }
}
    `;
export const RemoveChild = gql`
    mutation RemoveChild($childId: ID!) {
  removeChild(childId: $childId) {
    id
    children {
      id
      name
      surname
      health
      pesel
      address {
        street
        code
        city
      }
      birthday
      isIncomplete
    }
  }
}
    `;
export const UpdateGuardian = gql`
    mutation UpdateGuardian($guardianId: ID!, $input: AccountGuardianUpdateInput!) {
  updateGuardian(guardianId: $guardianId, input: $input) {
    id
    guardians {
      id
      name
      surname
      contactInfo {
        email
        phone
      }
    }
  }
}
    `;
export const AddGuardian = gql`
    mutation AddGuardian($input: AccountGuardianUpdateInput!) {
  addGuardian(input: $input) {
    id
    guardians {
      id
      name
      surname
      contactInfo {
        email
        phone
      }
    }
  }
}
    `;
export const RemoveGuardian = gql`
    mutation RemoveGuardian($guardianId: ID!) {
  removeGuardian(guardianId: $guardianId) {
    id
    guardians {
      id
      name
      surname
      contactInfo {
        email
        phone
      }
    }
  }
}
    `;
export const AddMembership = gql`
    mutation AddMembership($accountId: ID!, $childId: ID, $input: CartItemMembershipInput!) {
  addMembershipCartItem(accountId: $accountId, childId: $childId, input: $input) {
    id
    paymentOptions {
      id
    }
    items {
      ... on CartItemMembership {
        price {
          value
        }
        participant {
          ... on Account {
            name
          }
          ... on Child {
            name
          }
        }
      }
    }
  }
}
    `;
export const PlaceOrder = gql`
    mutation PlaceOrder($input: OrderPlacementInput!) {
  placeOrder(input: $input) {
    id
    payments {
      id
      dueDate
      link
      status
      price {
        value
      }
    }
  }
}
    `;
export const UpdateCustomData = gql`
    mutation UpdateCustomData($itemId: ID!, $data: JSONObject!) {
  cartItemUpdateCustomData(input: [{itemId: $itemId, data: $data}]) {
    id
    paymentOptions {
      id
      price {
        value
      }
    }
  }
}
    `;
export const GeneratePaymentLink = gql`
    mutation GeneratePaymentLink($orderId: ID!, $paymentId: ID!) {
  generatePaymentLink(orderId: $orderId, paymentId: $paymentId) {
    link
  }
}
    `;
export const CartAddDiscountCode = gql`
    mutation cartAddDiscountCode($code: String!) {
  cartAddDiscountCode(code: $code) {
    id
  }
}
    `;
export const CartRemoveDiscountCode = gql`
    mutation cartRemoveDiscountCode($code: String!) {
  cartRemoveDiscountCode(code: $code) {
    id
  }
}
    `;
export const GetMe = gql`
    query GetMe {
  me {
    id
    name
    surname
    contactInfo {
      email
      phone
    }
    pesel
    address {
      street
      code
      city
    }
    isIncomplete
    consents {
      knowledge
      health
      healthProcessing
      email
      text
      call
    }
    guardians {
      id
      name
      surname
      contactInfo {
        email
        phone
      }
    }
  }
}
    `;
export const GetMeId = gql`
    query GetMeId {
  me {
    id
  }
}
    `;
export const GetChildren = gql`
    query GetChildren {
  me {
    id
    address {
      street
      code
      city
    }
    children {
      id
      name
      surname
      health
      pesel
      canDelete
      deletionBlockers
      address {
        street
        code
        city
      }
      birthday
      isIncomplete
      summer2026: availableProducts(
        category: "Lato"
        period: {start: "2026-01-01", end: "2026-12-31"}
      ) {
        ... on IProduct {
          sku
          name
          stock {
            available
          }
          price {
            value
          }
        }
      }
      adventure2025: availableProducts(
        category: "Adventure Winter"
        period: {start: "2026-01-01", end: "2026-12-31"}
      ) {
        ... on IProduct {
          sku
          name
          stock {
            available
          }
          price {
            value
          }
        }
      }
      master2025: availableProducts(
        category: "Master"
        period: {start: "2026-01-01", end: "2026-12-31"}
      ) {
        ... on IProduct {
          sku
          name
          stock {
            available
          }
          price {
            value
          }
        }
      }
    }
  }
}
    `;
export const GetWinter = gql`
    query GetWinter {
  me {
    id
    activeOrders {
      id
    }
    children {
      id
      name
      surname
      isIncomplete
      canDelete
      availableProducts(category: "Camp") {
        ... on IProduct {
          name
          sku
          price {
            currency
            value
          }
          stock {
            available
            total
          }
        }
      }
    }
  }
}
    `;
export const GetOrders = gql`
    query GetOrders {
  me {
    id
    name
    surname
    isIncomplete
    consents {
      knowledge
      health
      healthProcessing
      email
      text
      call
    }
    cart {
      discounts {
        code
      }
      discountCodes {
        code
        description
        expirationDate
      }
      paymentOptions {
        id
        name
        description
        price {
          value
        }
        payments {
          name
          dueDate
          price {
            value
          }
          items {
            ...Membership
            ...Activity
            ...WinterCamp
            ...SummerCamp
            ...NewWinterCamp
          }
          bundles {
            ...ActivityBundle
            ...Membership
            ...WinterCamp
            ...SummerCamp
            ...NewWinterCamp
          }
        }
      }
      itemsGroups {
        participant {
          ... on Child {
            __typename
            id
            name
            surname
            membership {
              membershipType: type
            }
          }
          ... on Account {
            __typename
            id
            name
            surname
            membership {
              membershipType: type
            }
          }
        }
        bundles {
          ...ActivityBundle
          ...Membership
          ...WinterCamp
          ...SummerCamp
          ...NewWinterCamp
        }
        problems {
          ...CartProblemFragment
        }
      }
      problems {
        ...CartProblemFragment
      }
      discounts {
        source
        reason
        message
        code
        discountValue {
          __typename
          ... on DiscountPercentage {
            value
          }
          ... on Price {
            value
            currency
          }
        }
      }
    }
  }
}
    ${Membership}
${Activity}
${WinterCamp}
${SummerCamp}
${NewWinterCamp}
${ActivityBundle}
${CartProblemFragment}`;
export const GetPaymentOptionId = gql`
    query GetPaymentOptionId {
  me {
    id
    cart {
      paymentOptions {
        id
        price {
          value
        }
      }
    }
  }
}
    `;
export const GetActiveOrders = gql`
    query GetActiveOrders {
  me {
    id
    activeOrders {
      id
      date
      fullyPaid
      documents {
        id
        name
        description
        link
      }
      price {
        value
      }
      payments {
        id
        name
        dueDate
        status
        link
        price {
          value
        }
      }
      itemsGroups {
        participant {
          ... on Child {
            __typename
            id
            name
            surname
            membership {
              membershipType: type
            }
          }
          ... on Account {
            __typename
            id
            name
            surname
            membership {
              membershipType: type
            }
          }
        }
        bundles {
          __typename
          ... on OrderItemMembership {
            membershipType: type
            price {
              value
            }
            period {
              start
              end
              name
            }
          }
          ... on OrderItemActivityBundle {
            sport
            location
            type
            entries
            dayTimes {
              day
              time
            }
            unitPrice {
              value
            }
            price {
              value
            }
            period {
              start
              end
              name
            }
          }
          ... on OrderItemWinterCamp {
            __typename
            sku
            name
            sport
            level
            price {
              value
            }
            discounts {
              reason
              source
              message
              discountValue {
                ... on Price {
                  value
                }
                ... on DiscountPercentage {
                  percentage: value
                }
              }
            }
            participant {
              ... on Child {
                __typename
                id
                name
                surname
                membership {
                  membershipType: type
                }
              }
              ... on Account {
                __typename
                id
                name
                surname
                membership {
                  membershipType: type
                }
              }
            }
          }
          ... on OrderItemSummerCamp {
            __typename
            sku
            name
            price {
              value
            }
            profile
            discounts {
              reason
              source
              message
              discountValue {
                ... on Price {
                  value
                }
                ... on DiscountPercentage {
                  percentage: value
                }
              }
            }
            participant {
              ... on Child {
                __typename
                id
                name
                surname
                membership {
                  membershipType: type
                }
              }
              ... on Account {
                __typename
                id
                name
                surname
                membership {
                  membershipType: type
                }
              }
            }
          }
          ... on OrderItemNewWinterCamp {
            __typename
            sku
            name
            price {
              value
            }
            profile
            discounts {
              reason
              source
              message
              discountValue {
                ... on Price {
                  value
                }
                ... on DiscountPercentage {
                  percentage: value
                }
              }
            }
            participant {
              ... on Child {
                __typename
                id
                name
                surname
                membership {
                  membershipType: type
                }
              }
              ... on Account {
                __typename
                id
                name
                surname
                membership {
                  membershipType: type
                }
              }
            }
          }
        }
      }
    }
  }
}
    `;
export const GetArchiveOrders = gql`
    query GetArchiveOrders {
  me {
    id
    archiveOrders {
      id
      date
      fullyPaid
      price {
        value
      }
      documents {
        id
        name
        description
        link
      }
      payments {
        id
        name
        dueDate
        status
        link
        price {
          value
        }
      }
      itemsGroups {
        participant {
          ... on Child {
            __typename
            id
            name
            surname
            membership {
              membershipType: type
            }
          }
          ... on Account {
            __typename
            id
            name
            surname
            membership {
              membershipType: type
            }
          }
        }
        bundles {
          __typename
          ... on OrderItemMembership {
            membershipType: type
            price {
              value
            }
            period {
              start
              end
              name
            }
          }
          ... on OrderItemActivityBundle {
            sport
            location
            type
            entries
            dayTimes {
              day
              time
            }
            unitPrice {
              value
            }
            price {
              value
            }
            period {
              start
              end
              name
            }
          }
          ... on OrderItemSummerCamp {
            __typename
            sku
            name
            price {
              value
            }
            profile
            discounts {
              reason
              source
              message
              discountValue {
                ... on Price {
                  value
                }
                ... on DiscountPercentage {
                  percentage: value
                }
              }
            }
            participant {
              ... on Child {
                __typename
                id
                name
                surname
                membership {
                  membershipType: type
                }
              }
              ... on Account {
                __typename
                id
                name
                surname
                membership {
                  membershipType: type
                }
              }
            }
          }
          ... on OrderItemNewWinterCamp {
            __typename
            sku
            name
            price {
              value
            }
            profile
            discounts {
              reason
              source
              message
              discountValue {
                ... on Price {
                  value
                }
                ... on DiscountPercentage {
                  percentage: value
                }
              }
            }
            participant {
              ... on Child {
                __typename
                id
                name
                surname
                membership {
                  membershipType: type
                }
              }
              ... on Account {
                __typename
                id
                name
                surname
                membership {
                  membershipType: type
                }
              }
            }
          }
        }
      }
    }
  }
}
    `;
export const GetOrdersSummary = gql`
    query GetOrdersSummary {
  me {
    ordersSummary {
      cart
      active
      archive
    }
  }
}
    `;
export const GetAllActivities = gql`
    query GetAllActivities {
  me {
    id
    allActivities {
      participant {
        ... on Child {
          __typename
          id
          name
          surname
          membership {
            membershipType: type
          }
        }
        ... on Account {
          __typename
          id
          name
          surname
          membership {
            membershipType: type
          }
        }
      }
      bundles {
        __typename
        ... on OrderItemMembership {
          membershipType: type
          price {
            value
          }
        }
        ... on OrderItemActivityBundle {
          sport
          location
          type
          entries
          dayTimes {
            day
            time
          }
          unitPrice {
            value
          }
          price {
            value
          }
        }
      }
    }
  }
}
    `;
export const GetSummerCamps2026 = gql`
    query getSummerCamps2026 {
  summer2026: products(
    category: "Lato"
    period: {start: "2026-01-01", end: "2026-12-31"}
  ) {
    ... on IProduct {
      sku
      name
      stock {
        available
      }
    }
  }
}
    `;
export const GetWinterCamps2027 = gql`
    query getWinterCamps2027 {
  winter2027: products(
    category: "Zima 2027"
    period: {start: "2027-01-01", end: "2027-12-31"}
  ) {
    ... on IProduct {
      sku
      name
      stock {
        available
      }
    }
  }
}
    `;
export const GetNewWinterCamps2025 = gql`
    query getNewWinterCamps2025 {
  adventure2025: products(
    category: "Adventure Winter"
    period: {start: "2026-01-01", end: "2026-12-31"}
  ) {
    ... on IProduct {
      sku
      name
      stock {
        available
      }
    }
  }
  master2025: products(
    category: "Master"
    period: {start: "2026-01-01", end: "2026-12-31"}
  ) {
    ... on IProduct {
      sku
      name
      stock {
        available
      }
    }
  }
}
    `;
export const GetConsents = gql`
    query GetConsents {
  me {
    consents {
      call
      email
      health
      healthProcessing
      knowledge
      text
    }
  }
}
    `;
export const GetCartItemGroups = gql`
    query GetCartItemGroups {
  me {
    id
    isIncomplete
    cart {
      id
      itemsGroups {
        participant {
          ... on Account {
            id
          }
          ... on Child {
            id
          }
        }
      }
    }
  }
}
    `;
export const GetError = gql`
    query getError {
  me {
    id
  }
}
    `;
export const GetSummerCamps2026FromChild = gql`
    query getSummerCamps2026FromChild {
  me {
    id
    children {
      id
      name
      surname
      summer2026: availableProducts(
        category: "Lato"
        period: {start: "2026-01-01", end: "2026-12-31"}
      ) {
        ... on IProduct {
          sku
          name
          stock {
            available
          }
          price {
            value
          }
        }
      }
    }
  }
}
    `;
export const AddToCartSummerCamp = gql`
    mutation AddToCartSummerCamp($sku: ID!, $childId: ID!) {
  cartAddItem(sku: $sku, childId: $childId) {
    id
    problems {
      ... on ICartProblem {
        code
        message
      }
      ... on CartProblemCustomData {
        item {
          ... on ICartItem {
            id
            sku
          }
        }
        property
      }
    }
    items {
      ... on CartItemSummerCamp {
        sku
        id
      }
    }
  }
}
    `;
export const GetNewWinterCamps2025FromChild = gql`
    query getNewWinterCamps2025FromChild {
  me {
    id
    children {
      id
      name
      surname
      adventure2025: availableProducts(
        category: "Adventure Winter"
        period: {start: "2026-01-01", end: "2026-12-31"}
      ) {
        ... on IProduct {
          sku
          name
          stock {
            available
          }
          price {
            value
          }
        }
      }
      master2025: availableProducts(
        category: "Master"
        period: {start: "2026-01-01", end: "2026-12-31"}
      ) {
        ... on IProduct {
          sku
          name
          stock {
            available
          }
          price {
            value
          }
        }
      }
    }
  }
}
    `;
export const AddToCart = gql`
    mutation AddToCart($sku: ID!, $childId: ID!) {
  cartAddItem(sku: $sku, childId: $childId) {
    id
    problems {
      ... on ICartProblem {
        code
        message
      }
      ... on CartProblemCustomData {
        item {
          ... on ICartItem {
            id
            sku
          }
        }
        property
      }
    }
    items {
      ... on CartItemNewWinterCamp {
        sku
        id
      }
    }
  }
}
    `;
export const GetWinterCamps2027FromChild = gql`
    query getWinterCamps2027FromChild {
  me {
    id
    children {
      id
      name
      surname
      winter2027: availableProducts(
        category: "Zima 2027"
        period: {start: "2027-01-01", end: "2027-12-31"}
      ) {
        ... on IProduct {
          sku
          name
          stock {
            available
          }
          price {
            value
          }
        }
      }
    }
  }
}
    `;
export const AddToCartWinterCamp2027 = gql`
    mutation AddToCartWinterCamp2027($sku: ID!, $childId: ID!) {
  cartAddItem(sku: $sku, childId: $childId) {
    id
    problems {
      ... on ICartProblem {
        code
        message
      }
      ... on CartProblemCustomData {
        item {
          ... on ICartItem {
            id
            sku
          }
        }
        property
      }
    }
    items {
      ... on CartItemNewWinterCamp {
        sku
        id
      }
    }
  }
}
    `;